import(/* webpackMode: "eager" */ "/var/www/vhosts/restroai.de/httpdocs/src/app/register/page.tsx");
